import React, { useState } from 'react';
import { useSIPTelephony } from 'useCase';
import { SIPCallBoard } from './SIPCallBoard';
import { SIPKeypadButton } from './SIPKeypadButton';

// Компонент выводиться в списке учатников внизу.
// Открывает панель с формой ввода номера телефона
export const SIPCallPanel: React.FC = () => {
    const { isSIPOn } = useSIPTelephony();
    const [opened, setOpened] = useState(false);

    if (!isSIPOn()) return null;

    if (opened) {
        return <SIPCallBoard onClose={() => setOpened(false)} />;
    }

    return <SIPKeypadButton onClick={() => setOpened(true)} />;
};
